import { useEffect, useRef } from "react";
import style from "./ProgressBar.module.scss";

export type ProgressBarProps = {
  step: number;
  total: number;
};
export function ProgressBar({ step, total }: ProgressBarProps) {
  const progressRef = useRef<HTMLDivElement>(null);
  const percentage = Math.round((step / total) * 100);

  useEffect(() => {
    if (progressRef.current) {
      progressRef.current.style.setProperty(
        "--progress-width",
        `${percentage}%`
      );
    }
  }, [percentage]);

  return (
    <div ref={progressRef} className={style.progress}>
      <div className={style.bar} />
    </div>
  );
}
